import React, { useState, useEffect, Component, useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import moment from 'moment';
import Pagination from '../pagination/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { clearComparison } from '../../../Redux/actions/comparisonAction';
import { AiOutlinePrinter } from 'react-icons/ai';
import { getUserName } from '../../../Redux/selecters';
import { ClipLoader } from 'react-spinners';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Select from 'react-select';
import { toast } from 'react-toastify';

const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

const PriceComparisionGrid = () => {
    const [rowData, setRowData] = useState([]);
    const [PCrowData, setPCRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const apiService = new ApiService();
    const gridRef = useRef();
    let dispatch = useDispatch()
    let navigate = useNavigate();
    let userName = useSelector(getUserName)
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [permissions, setPermissions] = useState([]);
    const [POTab, setPOTab] = useState(false);
    const [pendingTab, setPendingTab] = useState(true);
    const [pcPagination, setPCPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedtem, setSelectedItem] = useState(null);
    const [searchLoader, setLoader] = useState(false);
    const [costCenter1, setCost1] = useState([]);

    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Price Comparison");
        setPermissions(permissions[0]);
    }, []);

    useEffect(() => {
        getItems();
        fetchCostCenter()
        getPC()
        // fetchInitialData();
    }, []);

    const [formData, setFormData] = useState({
        reqNo: "",
        requisitionNO: "",
        pcNo: "",
        quoteNo: "",
        costCenter1: [{ label: 'All', value: 'All' }],
    });
    const StatusFilter = [
        { value: '', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '5', label: 'Hold' },
        { value: '2', label: 'Rejected' },
    ];

    const fetchCostCenter = async () => {
        try {
            let cost1 = await apiService.get('GET_COST_ONE');
            setCost1([{ value: null, description: 'None' }, ...cost1?.data?.result]);
        } catch (error) {
            console.error('Error fetching Cost Center data:', error);
        }
    };

    const fetchInitialData = async () => {
        gridRef.current?.showLoadingOverlay();
        setLoading(true);
        setLoader(true);
        try {
            const prParams = new URLSearchParams();
            prParams.append('PageNo', 1);
            prParams.append('PageSize', pageSize || 20);
            prParams.append('id', formData?.reqNo || "");
            prParams.append('status', 1);
            prParams.append('reqType', "Purchase Requisition");
            prParams.append('ReqType2', "Purchase Request");

            const pcParams = new URLSearchParams();
            pcParams.append('PageNo', 1);
            pcParams.append('PageSize', pageSize || 20);



            const [prRes, pcRes, qotRes, cost1Res] = await Promise.all([
                apiService.getApiParamater('GET_PR_MASTER_FOR_PC', `?${prParams.toString()}`),
                apiService.getApiParamater('GET_PC', `?${pcParams.toString()}`),
                apiService.get('GET_QUOTATION'),
                apiService.get('GET_COST_ONE')
            ]);

            setCost1([{ value: null, description: 'None' }, ...cost1Res?.data?.result]);
            setPagination(prRes.data.paginationData);
            const recordMap = new Map(qotRes.data.result?.map(qot => [qot.requisitionNo, qot]));
            const pcRequisitionNos = new Set(pcRes.data.result?.map(pc => pc.requisitionNo));
            const newModifiedData = prRes?.data?.result?.map(item => {
                const matchingQotRecord = recordMap?.get(item?.requisitionNo?.toString());
                return { ...item, comparisonStatus: matchingQotRecord?.status || null, QuoteStatus: matchingQotRecord?.status || null, qotRecordId: matchingQotRecord?.quoteNo || null, found: !!matchingQotRecord?.recordId, compare: matchingQotRecord?.status === 1, };
            });
            const filteredModifiedData = newModifiedData?.filter(item => !pcRequisitionNos?.has(item.requisitionNo));
            setRowData(filteredModifiedData || []);
            setPCRowData(pcRes?.data?.result || []);
            setPCPagination(pcRes?.data?.paginationData);
        } catch (error) {
            console.error('Error fetching initial data:', error);
            toast.error("Failed to fetch data.");
        } finally {
            setLoading(false);
            setLoader(false);
            gridRef.current?.hideOverlay();
        }
    };

    const onGridReady = (params) => {
        gridRef.current = params.api;
        params.api.showLoadingOverlay();
    };
    const handleEdit = (data) => {
        dispatch(clearComparison());
        navigate("/Inventory/PriceComparison/price", { state: data })
    };
    const handleView = async (data) => {
        try {
            const params = new URLSearchParams();
            params.append("DocNo", data?.pcNo);
            params.append("Action", "CheckEditPCByDocId");

            const apiResponse = await apiService.getApiParamater(
                "GET_REQ_COMMON",
                `?${params.toString()}`
            );

            let dta = apiResponse?.data?.result?.data
            let finalData = []
            if (dta?.length > 0) {
                finalData = dta
            } else {
                finalData = [dta]
            }
            const isEditable = finalData?.some(
                item => item.IsRowEditable === true || 1
            );

            dispatch(clearComparison());

            if (isEditable) {
                const updatedData = {
                    ...data,
                    doctype: "UpdateComparison"
                };

                navigate(
                    `/Inventory/PriceComparison/View/${updatedData.pcNo}`,
                    { state: updatedData }
                );
            } else {
                const updatedData = {
                    ...data,
                    doctype: "Comparison",
                    eye: true
                };

                navigate(
                    `/Inventory/PriceComparison/View/${updatedData.pcNo}`,
                    { state: updatedData }
                );
            }
        } catch (error) {
            dispatch(clearComparison());

            const updatedData = {
                ...data,
                doctype: "Comparison",
                eye: true
            };

            navigate(
                `/Inventory/PriceComparison/View/${updatedData.pcNo}`,
                { state: updatedData }
            );
        }
    };
    const handleClearFilters = () => {
        const clearedFormData = {
            reqNo: "",
            requisitionNO: "",
            pcNo: "",
            quoteNo: "",
            costCenter1: [{ label: 'All', value: 'All' }],
        };
        setFormData(clearedFormData);
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            gridRef.current?.showLoadingOverlay();
            setLoader(true);
            setLoading(true);

            const params = new URLSearchParams();

            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('id', formData?.reqNo || "");
            params.append('status', 1);
            params.append('reqType', "Purchase Requisition");
            params.append('ReqType2', "Purchase Request");

            // ----------------------------------------------------
            // Fetch PR + PC + Quotation
            // ----------------------------------------------------
            const [res, pcRes, qotRes] = await Promise.all([
                apiService.getApiParamater(
                    'GET_PR_MASTER_FOR_PC',
                    `?${params.toString()}`
                ),
                apiService.get('GET_PC'),
                apiService.get('GET_QUOTATION')
            ]);

            const prResult = res?.data?.result || [];
            const pcResult = pcRes?.data?.result || [];
            const qotResult = qotRes?.data?.result || [];

            setPagination(res?.data?.paginationData);


            // ====================================================
            // 1. GROUP QUOTATIONS BY REQUISITION NO
            // ====================================================

            const quotationMap = new Map();

            qotResult.forEach(qot => {
                const requisitionNo = qot?.requisitionNo
                    ?.toString()
                    .trim();

                // Invalid quotation skip
                if (!requisitionNo) return;

                if (!quotationMap.has(requisitionNo)) {
                    quotationMap.set(requisitionNo, []);
                }

                quotationMap.get(requisitionNo).push(qot);
            });


            // ====================================================
            // 2. GROUP PC BY REQUISITION NO
            // ====================================================

            const pcMap = new Map();

            pcResult.forEach(pc => {
                const requisitionNo = pc?.requisitionNo
                    ?.toString()
                    .trim();

                // Invalid PC skip
                if (!requisitionNo) return;

                if (!pcMap.has(requisitionNo)) {
                    pcMap.set(requisitionNo, []);
                }

                pcMap.get(requisitionNo).push(pc);
            });


            // ====================================================
            // 3. PROCESS PR RESULT
            // ====================================================

            const newModifiedData = prResult
                .map(item => {

                    const requisitionNo = item?.requisitionNo
                        ?.toString()
                        .trim();

                    // ------------------------------------------------
                    // No requisitionNo => skip this record
                    // ------------------------------------------------
                    if (!requisitionNo) {
                        return null;
                    }


                    // ------------------------------------------------
                    // Get all quotations for this requisition
                    // ------------------------------------------------
                    const quotations =
                        quotationMap.get(requisitionNo) || [];


                    // ------------------------------------------------
                    // Get all PCs for this requisition
                    // ------------------------------------------------
                    const pcs =
                        pcMap.get(requisitionNo) || [];


                    const quotationCount = quotations.length;
                    const pcCount = pcs.length;


                    // =================================================
                    // 4. FIND LATEST QUOTATION
                    // =================================================

                    const latestQuotation = quotations.length
                        ? [...quotations].sort((a, b) => {

                            const dateDiff =
                                new Date(b?.quoteDate || 0) -
                                new Date(a?.quoteDate || 0);

                            // If dates are different,
                            // latest date comes first
                            if (dateDiff !== 0) {
                                return dateDiff;
                            }

                            // If dates are same,
                            // use recordId as fallback
                            return (
                                (b?.recordId || 0) -
                                (a?.recordId || 0)
                            );
                        })[0]
                        : null;


                    // =================================================
                    // 5. NO QUOTATION
                    // =================================================

                    if (!latestQuotation) {

                        return {
                            ...item,

                            quotationData: null,
                            tempQuotationDetails: [],

                            qotRecordId: null,

                            QuoteStatus: null,
                            comparisonStatus: null,

                            found: false,
                            compare: false,

                            isFresh: true,

                            quotationCount,
                            pcCount
                        };
                    }


                    // =================================================
                    // 6. CHECK LATEST QUOTE NO
                    //    AGAINST PC
                    // =================================================

                    const latestQuoteNo =
                        latestQuotation?.quoteNo
                            ?.toString()
                            .trim() || "";


                    const latestQuoteAlreadyInPC = pcs.some(
                        pc =>
                            pc?.quoteNo
                                ?.toString()
                                .trim() === latestQuoteNo
                    );


                    // =================================================
                    // 7. LATEST QUOTATION ALREADY USED IN PC
                    // =================================================
                    //
                    // Example:
                    //
                    // QOT:
                    // QT/100952
                    // QT/100953  <-- latest
                    //
                    // PC:
                    // QT/100952
                    // QT/100953
                    //
                    // Result:
                    // Fresh
                    //
                    // =================================================

                    if (latestQuoteAlreadyInPC) {

                        return {
                            ...item,

                            quotationData: null,
                            tempQuotationDetails: [],

                            qotRecordId: null,

                            QuoteStatus: null,
                            comparisonStatus: null,

                            found: false,
                            compare: false,

                            isFresh: true,

                            quotationCount,
                            pcCount
                        };
                    }


                    // =================================================
                    // 8. LATEST QUOTATION NOT USED IN PC
                    //    => BIND IT
                    // =================================================

                    return {
                        ...item,

                        // Complete quotation object
                        quotationData: latestQuotation,

                        // Quotation details
                        tempQuotationDetails:
                            latestQuotation?.tempQuotationDetails || [],

                        // Latest Quote No
                        qotRecordId:
                            latestQuotation?.quoteNo || null,

                        // Status
                        QuoteStatus:
                            latestQuotation?.status ?? null,

                        comparisonStatus:
                            latestQuotation?.status ?? null,

                        // Quotation found
                        found: true,

                        // Status 1 => compare
                        compare:
                            latestQuotation?.status === 1,

                        isFresh: false,

                        quotationCount,
                        pcCount
                    };
                })
                .filter(Boolean);


            // ====================================================
            // 9. SET FINAL DATA
            // ====================================================

            setRowData(newModifiedData);


        } catch (error) {

            console.error(
                'Error fetching items:',
                error
            );

        } finally {

            setLoader(false);
            setLoading(false);

            gridRef.current?.hideOverlay();
        }
    };
    const getPC = async (newPageNo = pcPagination?.currentPage) => {
        try {
            gridRef.current?.showLoadingOverlay();
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('PCNo', formData?.pcNo || '');
            params.append('QuoteNo', formData?.quoteNo || '');
            params.append('RequisitionNo', formData?.requisitionNO || '');
            params.append('CostCenter1', formData?.costCenter1?.label || '');
            const res = await apiService.getApiParamater('GET_PC', `?${params.toString()}`);
            const data = res?.data?.result || [];
            setPCRowData(data);
            setPCPagination(res?.data?.paginationData)
            setLoading(false);
            gridRef.current?.hideOverlay();
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
            gridRef.current?.hideOverlay();
        }
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1?.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : "";
    };
    const Comparison = [
        { checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },

        {
            headerName: 'Req No', field: 'requisitionNo', suppressMovable: true, width: 150,
        },
        {
            headerName: 'Quote No', field: 'quoteNo', suppressMovable: true, width: 150,
        },
        {
            headerName: 'PC No', field: 'pcNo', suppressMovable: true, width: 150,
        },
        {
            headerName: 'Date', field: 'pcDate',
            floatingfilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
            suppressMovable: true, width: 150
        },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 150 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 150 },
        { headerName: 'Cost Centre 3', field: 'costCenter3', suppressMovable: true, width: 150 },
        {
            headerName: 'Status', field: 'status',
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                } else {
                    return params.value;
                }
            }, suppressMovable: true, width: 180
        },
        {
            headerName: 'Approval date', field: 'approvalDate', suppressMovable: true, width: 140,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        {
            headerName: 'Active', field: 'id', cellRenderer: PrinterBtn,
            cellRendererParams: {
                permissions: permissions,
                handleView: handleView,
                clicked: function (field, isActive) {
                    // updateActiveStatus(field, isActive);
                },
            },
        }
    ];
    const columnDefs = [
        { headerName: 'Req No', field: 'requisitionNo', suppressMovable: true, width: 150 },
        {
            headerName: 'Quote No',
            field: 'qotRecordId',
            suppressMovable: true,
            width: 150,
            cellRenderer: (params) => {
                if (!params.value) {
                    return '-';
                }

                return (
                    <button
                        type="button"
                        className="btn p-0 border-0 bg-transparent"
                        style={{
                            color: '#1032E7',
                            textDecoration: 'underline',
                            cursor: 'pointer'
                        }}
                        onClick={() => handlePrint(params.data)}
                    >
                        {params.value}
                    </button>
                );
            }
        },
        {
            headerName: 'Date', field: 'requisitionDate',
            floatingfilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
            suppressMovable: true, width: 120
        },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 210 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 210 },
        { headerName: 'Cost Centre 3', field: 'costCenter3', suppressMovable: true, width: 150 },
        {
            headerName: 'Status', field: 'comparisonStatus', suppressMovable: true, width: 150,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                } else {
                    return params.value;
                }
            }
        },
        {
            headerName: 'Quotations', suppressMovable: true, width: 130,
            cellRenderer: function (params) {
                if (params.data.comparisonStatus === 1) {
                    return (
                        <button style={{ color: '#1032E7', textDecoration: 'none', border: "none" }} disabled class="btn ">Quotation</button>
                    );
                } else {
                    return (
                        <>
                            {permissions?.canAdd === false ?
                                <button style={{ color: '#1032E7', textDecoration: 'none', border: "none" }} disabled class="btn ">Quotation</button> :
                                <>
                                    {params.data.QuoteStatus === 1 || params.data.QuoteStatus === 5 ?
                                        <button style={{ color: '#1032E7', textDecoration: 'none', border: "none" }} disabled class="btn ">Quotation</button> :

                                        <button style={{ color: '#1032E7', textDecoration: 'underline' }} onClick={() => handleComparison(params?.data)} class="btn ">Quotation</button>
                                    }
                                </>
                            }
                        </>
                    );
                }
            }
        }, {
            headerName: 'Price Comparison', field: 'id', cellRenderer: BtnCellRenderer,
            cellRendererParams: {
                permissions: permissions,
                handleEdit: handleEdit,
                clicked: function (field, isActive) {
                    // updateActiveStatus(field, isActive);
                },
            },
        }
    ];
    const frameworkComponents = {
        btnCellRenderer: BtnCellRenderer,
    };
    const handlePrint = (data) => {
        if (data || selectedRow) {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'userName', value: userName },
                    { name: 'reportName', value: 'PriceComparison' },
                    { name: 'voucherNo', value: data?.requisitionNo || selectedRow?.requisitionNo },
                ];
debugger;
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
        }
    };
    const handleComparison = (data) => {
        dispatch(clearComparison());
        navigate("/Inventory/PriceComparison/price", { state: data })
    }
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
        setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
    };
    const handleStatusChange = (selectedOption) => {
        setFormData({ ...formData, costCenter1: selectedOption });
    };
    return (
        <div className='p-4'>
            <h4 className='col mainInvHead'>Price Comparison</h4>

            <div className='gridBg mx-1' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row d-flex justify-content-between'>
                    <div className='col-5 d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Requisition No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.reqNo}
                            name="reqNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col'></div>
                    <div className='col-2'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getItems(1)} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                    <div className='col-2'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="cost-center-section">
                    <div className="d-flex mt-3 cursor-pointer slide-header"
                        onClick={() => setPendingTab(!pendingTab)}>
                        <div className='h6 pt-1'>Pending For Price Comparison</div>
                    </div>
                    <div className={`slide-content ${pendingTab ? 'open' : 'closed'}`}>
                        <div className={`border-box2 p-2${pendingTab ? 'slide-in' : 'slide-out'}`}>
                            <div className="ag-theme-quartz" style={{ height: 500 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    onGridReady={onGridReady}
                                    floatingFilter={true}
                                    rowSelection={'single'}
                                    columnDefs={columnDefs}
                                    pagination={false}
                                    suppressExcelExport={true}
                                    suppressRowClickSelection={true}
                                    frameworkComponents={{ frameworkComponents }}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridBg mx-1' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row d-flex justify-content-between'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Requisition No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData?.requisitionNO}
                            name="requisitionNO"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Quote No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData?.quoteNo}
                            name="quoteNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col-3'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getPC()} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                </div>
                <div className='row mt-2 d-flex jusitfy-content-end'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">PC No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.pcNo}
                            name="pcNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Property</label>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 2,
                                height: 25,
                                minHeight: 25
                            })}
                            className="w-100 p-0"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.costCenter1}
                            onChange={(selectedOption) => handleStatusChange(selectedOption)}
                            options={costCenter1?.map((sup) => ({ value: sup, label: sup?.description }))}
                        />
                    </div>
                    <div className='col-3'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex justify-content-between mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Price Comparison</div>
                    <div className='end'>
                        <div
                            onClick={handlePrint}
                            className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                            style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                        >
                            <AiOutlinePrinter color="#fff" className="center mt-1 mx-2" />
                            <div className="center">Print</div>
                        </div>
                    </div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-2${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="ag-theme-quartz" style={{ height: 500 }}>
                            <AgGridReact
                                getRowStyle={(params) => {
                                    if (params.node.rowIndex % 2 === 0) {
                                        return { background: '#F0EDF5' };
                                    } else {
                                        return { background: '#fff' };
                                    }
                                }}
                                rowData={PCrowData}
                                enableFilter={true}
                                floatingFilter={true}
                                rowSelection={'single'}
                                columnDefs={Comparison}
                                pagination={false}
                                suppressExcelExport={true}
                                onGridReady={onGridReady}
                                suppressRowClickSelection={true}
                                onSelectionChanged={onSelectionChanged}
                                frameworkComponents={{ frameworkComponents }}
                            />
                        </div>
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pcPagination} getItems={getPC} />
                    </div>
                </div>
            </div>
        </div>
    );
};
class BtnCellRenderer extends Component {

    btnClickedHandler() {
        const { value, clicked } = this.props;
        clicked(value);
    }
    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
        this.btnEditClickedHandler = this.btnEditClickedHandler.bind(this);
    }

    btnEditClickedHandler() {
        const { data, handleEdit } = this.props;
        handleEdit(data);
    }

    render() {
        const { data } = this.props;
        const { canEdit } = this.props;
        const { permissions } = this.props;
        const isDisabled = data.comparisonStatus !== 1;
        const buttonStyle = isDisabled ? { cursor: 'not-allowed' } : {};
        return (
            <div>
                {!isDisabled ?
                    <button
                        onClick={this.btnEditClickedHandler}
                        className="gridbtn p-0"
                        disabled={permissions?.canAdd === false ? true : isDisabled}
                        style={buttonStyle}
                    >
                        Price Comparison
                    </button> :
                    <button
                        className="gridDisab p-0"
                        disabled={permissions?.canAdd === false ? true : isDisabled}
                        style={buttonStyle}
                    >
                        Price Comparison
                    </button>}
            </div>
        );
    }
}
class PrinterBtn extends Component {
    btnClickedHandler() {
        const { value, clicked } = this.props;
        clicked(value);
    }
    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
        this.btnEditClickedHandler = this.btnEditClickedHandler.bind(this);
    }

    btnEditClickedHandler() {
        const { data, handleView } = this.props;
        handleView(data);
    }

    render() {
        const { data } = this.props;
        const { canEdit } = this.props;
        const { permissions } = this.props;
        const isDisabled = data.comparisonStatus !== 1 || data.comparisonStatus !== 5
        const { status } = this.props;

        return (
            <div>
                {!isDisabled ?
                    <button onClick={this.btnEditClickedHandler}
                        className="gridbtn p-0"
                        style={{ cursor: permissions?.canUpdate === true ? 'pointer' : 'not-allowed' }}
                        disabled={permissions?.canUpdate === false ? true : false}
                    >Price Comparison
                    </button> :
                    <button onClick={this.btnEditClickedHandler}
                        className="gridbtn p-0"
                        style={{ cursor: permissions?.canUpdate === true ? 'pointer' : 'not-allowed' }}
                        disabled={permissions?.canUpdate === false ? true : false}
                    >Price Comparison
                    </button>}
            </div>
        )
    }
}
export default PriceComparisionGrid; 